import httpClient from "./httpClient";

export const getSolutionDetails = async () => {
  return await httpClient.get("/api/solutions");
};
